import React from "react";

import styled from "styled-components";
import { Badge } from "ui/core";
import { BadgeColor } from "ui/core/Badge";

export interface ScopesProps {
  items: number | number[];
}

const Scopes: React.FC<ScopesProps> = ({ items }) => {
  const scopes = new Set(Array.isArray(items) ? items : [items]);
  return (
    <ScopesWrapper>
      {Array.from(scopes).map((scope) => (
        <Badge
          key={scope}
          color={ScopeColors[scope] ?? "initial"}
          size="medium"
        >
          S{scope}
        </Badge>
      ))}
    </ScopesWrapper>
  );
};

const ScopeColors: Record<number, BadgeColor> = {
  1: "success",
  2: "error",
  3: "warning",
} as const;

const ScopesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 4px;
`;

export default Scopes;
